export class Menu {
  constructor() {
    this.dropDownMenuBtn = $("#dropdown-menu-btn");
    this.partnersBtn = $("#partners-btn");
    this.menuBarMobile = $("#menu-bar-mobile");
    this.navHideMenu = $("#nav-hide-menu");
    this.navPartners = $("#nav-partners");
    this.closeIcon = $("#dropdown-menu-btn img");
    this.knowMoreMobileBtn = $("#know-more-btn");
    this.navKnowMore = $("#nav-know-more");
    this.backMobileBtn = $("#menu-bar-mobile li:first-child");
    this.partnersDropDownBtn = $("#parternsDropDownBtn");
    this.partnersDropDownDiv = $("#dropDownPartners");
    this.headerKnowMore = $("#header-know-more");
    this.headerKnowMoreContent = $("#header-know-more-content");
    this.dropDownMenu = $(".dropdown-menu");
    this.helpButton = $("#help-button");
  }

  openMobileMenuListener() {
    this.menuBarMobile
      .css("display", "unset")
      .removeClass("slide-out-left")
      .addClass("slide-in-left")
      .css("z-index", "1001");

    this.navHideMenu.removeClass("slide-out-left").addClass("slide-in-left");

    this.closeIcon.attr("src", "/static/images/icons/x-alerta.png");
  }

  openAndCloseKnowMoreDropDownListener() {
    this.headerKnowMore
      .on("clickout", () => {
        if (this.headerKnowMoreContent.css("visibility") != "hidden")
          this.rotateArrowIcon("#know-more-arrow");
        this.headerKnowMoreContent.css("visibility", "hidden");
      })
      .click(() => {
        this.rotateArrowIcon("#know-more-arrow");
        this.headerKnowMoreContent.css("visibility") == "visible"
          ? this.headerKnowMoreContent.css("visibility", "hidden")
          : this.headerKnowMoreContent.css("visibility", "visible");
      });
  }

  closeMobileMenuListener() {
    this.navHideMenu.removeClass("slide-in-left").addClass("slide-out-left");

    this.menuBarMobile.removeClass("slide-in-left").addClass("slide-out-left");

    this.closeIcon.attr("src", "/static/images/icons/Menu.png");

    setTimeout(() => {
      this.navPartners.css("display", "none");
    }, 100);

    setTimeout(() => {
      this.menuBarMobile.css("display", "none");
    }, 700);
  }

  subNavMenuMobileCloseListener(jquerySelector) {
    jquerySelector.removeClass("slide-in-left").addClass("slide-out-left");
    setTimeout(function () {
      jquerySelector.css("display", "none");
    }, 500);
  }

  partnerOpenAndCloseDropDownListener() {
    this.partnersDropDownBtn
      .click(() => {
        const isShow = this.partnersDropDownDiv.attr("class").includes("show");
        isShow
          ? this.partnersDropDownDiv.removeClass("show").css("display", "none")
          : this.partnersDropDownDiv.addClass("show").css("display", "grid");
        this.rotateArrowIcon("#parterns-arrow");
      })
      .on("clickout", () => {
        if (this.dropDownMenu.attr("class").search("show") > 0)
          this.rotateArrowIcon("#parterns-arrow");
        this.dropDownMenu.hide().removeClass("show");
      });
  }

  rotateArrowIcon(selector) {
    const matrix = "matrix(-1, 0, 0, -1, 0, 0)";
    $(selector).css("transition", "transform .2s");
    $(selector).css("transform") == matrix
      ? $(selector).css("transform", "rotate(0deg)")
      : $(selector).css("transform", "rotate(180deg)");
  }

  scrollHelpToView() {
    document.getElementById("help").scrollIntoView(true);
    return;
  }
  
  static menuMobileOpenAndCloseListener() {
    const menu = new Menu();
    menu.dropDownMenuBtn.click(() => {
      menu.menuBarMobile.css("display") == "none"
        ? menu.openMobileMenuListener()
        : menu.closeMobileMenuListener();
    });
  }

  static partnersMobileListener() {
    const menu = new Menu();
    menu.partnersBtn.click(() => {
      if (menu.navPartners.css("display") == "none") {
        menu.navPartners
          .css("display", "flex")
          .removeClass("slide-out-left")
          .addClass("slide-in-left");
      }
    });
  }

  static partnersDropDownListener() {
    const menu = new Menu();
    menu.partnerOpenAndCloseDropDownListener();
  }

  static knowMoreDropDownListener() {
    const menu = new Menu();
    menu.openAndCloseKnowMoreDropDownListener();
  }

  static knowMoreMobileListener() {
    const menu = new Menu();
    menu.knowMoreMobileBtn.click(() => {
      const isOpen = menu.navKnowMore.css("display") == "none";
      if (isOpen) {
        menu.navKnowMore
          .css("display", "flex")
          .removeClass("slide-out-left")
          .addClass("slide-in-left");
      }
    });
  }

  static subMenuMobileCloseListener() {
    const menu = new Menu();
    menu.backMobileBtn.click(() => {
      if (menu.navPartners.css("display") == "flex")
        menu.subNavMenuMobileCloseListener(menu.navPartners);
      if (menu.navKnowMore.css("display") == "flex")
        menu.subNavMenuMobileCloseListener(menu.navKnowMore);
    });
  }

  static scrollToHelpListener() {
    const menu = new Menu();
    menu.helpButton.click(async() => {
      
      menu.scrollHelpToView();
      setTimeout(() => menu.scrollHelpToView(), 500)
      return false;
    });
  }
}
